module.exports = __webpack_public_path__ + "static/media/search.c160cdf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/search.svg
// module id = 167
// module chunks = 0